var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var _ = require('underscore');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		var title = this.props.title;
  		  	title = title.replace('&amp;', '&');
  		  	title = title.replace('&amp;', '&');
  		  		
  		  	console.log(this.props);	
  		// Filled
  		if(typeof this.props.job.is_filled != 'undefined'){
			var salary = '';	
			var sub_title = ''; 
			title = this.props.job.title; 	
			
			var logo = (typeof this.props.company_logo != 'undefined' && this.props.company_logo != '') ? (<img src={this.props.company_logo} />) : '';
	  		
	  		if(logo == '' && this.props.env_info.name != 'vel'){
		  		logo = (<img src={this.props.env_info.logo} />);
	  		}
	  		
		// Open	
  		} else {
	  		var logo = (this.props.company_logo != '') ? (<img src={this.props.company_logo} />) : '';
	  		
	  		if(!_.isUndefined(this.props.job.publish_picture) && this.props.job.publish_picture !== ''){
	  			logo = (<img src={this.props.job.publish_picture} />);
	  		}
  		
	  		if(logo == '' && this.props.env_info.name != 'vel'){
		  		logo = (<img src={this.props.env_info.logo} />);
	  		}
	  		
	  		if(this.props.job.salary_fixed.indexOf('-') != -1){
				var salary_string = this.props.job.salary_fixed;
			} else {
				var salary_string = this.props.job.salary_fixed+' - '+this.props.job.salary_bonus;
			}
			
			salary_string = salary_string.replace(/€/ig, '');
				
			var salary = (this.props.job.salary_fixed != '' || this.props.job.salary_bonus) ? (<div className="job-salary"><span className="fa icon fa-euro"></span>{salary_string}</div>) : '';
			
			var sub_title = (this.props.sub_title !== '') ? (<span className="sub-title">{this.props.sub_title}</span>) : '';
  		}
  		
  		console.log('SUB', title, this.props)
  		
   		return (
   			<div className="job-title">
   				{logo}
   				
      			<h1>{title}{salary}{sub_title}</h1>
      			<div className="title-bg"></div>
	  		</div>
	  	);
	}
});
